<app-accordion-help [helps]="helps"></app-accordion-help>

<div style="margin-top: 20px; margin-left: 20px;">


  <div fxLayout="row wrap" fxLayoutAlign="start" fxLayoutGap="20px"
       ngClass.xs="page-margin-xs"
       ngClass.sm="page-margin-sm"
       ngClass="page-margin">


    <!--https://icons8.com/icons/set/google-ads -->
    <div ngClass="table-width" ngClass.xs="table-width-xs">
      <mat-card style="height:25px;width: 25px;"  (click)="onCardClick($event, 'googleads')" matRipple class="clickable my-class">
<!--        <mat-card-header>Click Funnels</mat-card-header>-->
        <img mat-card-image src="assets/integrations/icons8-google-ads-48.svg" >
        <mat-card-content>
<!--          <img mat-card-image src="assets/integrations/click_funnels2.svg" >-->
        </mat-card-content>

      </mat-card>
    </div>

    <!--https://icons8.com/icons/set/google-ads -->
    <div ngClass="table-width" ngClass.xs="table-width-xs">
      <mat-card style="height:25px;width: 25px;"  (click)="onCardClick($event, 'facebook')" matRipple class="clickable my-class">

        <img mat-card-image src="assets/integrations/icons8-facebook.svg" >
        <mat-card-content>
        </mat-card-content>

      </mat-card>
    </div>

    <div ngClass="table-width" ngClass.xs="table-width-xs">
      <mat-card style="height:25px;width: 25px;"  (click)="onCardClick($event,'clickfunnels')" matRipple class="clickable my-class">
        <!--        <mat-card-header>Click Funnels</mat-card-header>-->
        <img mat-card-image src="assets/integrations/click_funnels2.svg" >
        <mat-card-content>
          <!--          <img mat-card-image src="assets/integrations/click_funnels2.svg" >-->
        </mat-card-content>
      </mat-card>
    </div>


    <div ngClass="table-width" ngClass.xs="table-width-xs">
      <mat-card style="height:25px;width: 25px;"  (click)="onCardClick($event,'shopify')" matRipple class="clickable my-class">
        <!--        <mat-card-header>Click Funnels</mat-card-header>-->
        <img mat-card-image src="assets/integrations/icons8-shopify.svg" >
        <mat-card-content>
          <!--          <img mat-card-image src="assets/integrations/click_funnels2.svg" >-->
        </mat-card-content>
      </mat-card>
    </div>


<!--    <div ngClass="table-width" ngClass.xs="table-width-xs">-->
<!--      <mat-card></mat-card>-->
<!--    </div>-->


<!--    <div ngClass="table-width" ngClass.xs="table-width-xs">-->
<!--      <mat-card></mat-card>-->
<!--    </div>-->


  </div> <!--end fxLayload-->

</div>
